import { useEffect, useState } from "react";
import { dashboardService } from "../../services/api";
import { fmtCurrencyBR } from "../../utils/formatBrl";

export default function AdminTopSellers() {
	const [topSellers, setTopSellers] = useState([]);
	const [loading, setLoading] = useState(false);
	const [filters, setFilters] = useState({ start_date: "", end_date: "" });

	useEffect(() => {
		load();
		// eslint-disable-next-line
	}, []);

	const load = async () => {
		try {
			setLoading(true);
			const { data } = await dashboardService.getAdminPayments({ ...filters, page: 1 });
			setTopSellers(data.top_sellers || []);
		} catch (err) {
			console.error(err);
		} finally {
			setLoading(false);
		}
	};

	const handleFilterChange = (e) => {
		setFilters((prev) => ({ ...prev, [e.target.name]: e.target.value }));
	};

	return (
		<>
			<div className="filters-section">
				<div className="filters-grid">
					<div className="filter-group">
						<input
							type="date"
							name="start_date"
							value={filters.start_date}
							onChange={handleFilterChange}
							className="filter-input"
						/>
					</div>
					<div className="filter-group">
						<input
							type="date"
							name="end_date"
							value={filters.end_date}
							onChange={handleFilterChange}
							className="filter-input"
						/>
					</div>
					<button onClick={load} className="btn-primary">
						Aplicar Filtros
					</button>
				</div>
			</div>

			{loading ? (
				<div className="loading mt-6">
					<i className="fas fa-spinner fa-spin" /> Carregando...
				</div>
			) : (
				<>
					{/* Desktop */}
					<div className="sx-desktop mt-6">
						<table className="sx-table">
							<thead>
								<tr>
									<th>#</th>
									<th>Usuário</th>
									<th>Faturamento</th>
									<th>Pagamentos</th>
									<th>Comissão</th>
								</tr>
							</thead>
							<tbody>
								{topSellers.length === 0 ? (
									<tr>
										<td colSpan={5}>
											<div className="empty-state">
												<i className="fas fa-trophy" />
												<h4>Nenhum dado encontrado</h4>
											</div>
										</td>
									</tr>
								) : (
									topSellers.map((s, i) => (
										<tr key={s.id}>
											<td>{i + 1}</td>
											<td>{s.username}</td>
											<td>{fmtCurrencyBR.format(s.gross_amount)}</td>
											<td>{s.payments_count}</td>
											<td>{fmtCurrencyBR.format(s.total_split)}</td>
										</tr>
									))
								)}
							</tbody>
						</table>
					</div>

					{/* Mobile */}
					<div className="sx-mobile mt-6">
						{topSellers.length === 0 ? (
							<div className="empty-state">
								<i className="fas fa-trophy" />
								<h4>Nenhum dado encontrado</h4>
							</div>
						) : (
							topSellers.map((s, i) => (
								<div key={s.id} className="mobile-card">
									<div className="sx-card-header">
										<span className="sx-card-title">#{i + 1} {s.username}</span>
										<span className="sx-card-meta">{s.payments_count} pagamentos</span>
									</div>
									<div className="sx-card-row">
										<span style={{ color: "var(--text-secondary)" }}>Faturamento: </span>
										<strong>{fmtCurrencyBR.format(s.gross_amount)}</strong>
									</div>
									<div className="sx-card-row">
										<span style={{ color: "var(--text-secondary)" }}>Comissão: </span>
										<strong>{fmtCurrencyBR.format(s.total_split)}</strong>
									</div>
								</div>
							))
						)}
					</div>
				</>
			)}
		</>
	);
}
